/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Set up jQuery & Bootstrap
window.$ = window.jQuery = require("jquery");

// Require
require("gasparesganga-jquery-loading-overlay");
require('readmore-js');
require('jquery-counter');

// Import custom modules
import 'bootstrap';
import Lightbox from "lightbox2";
import App from './modules/app.js';
import Hero from './modules/hero.js';
import BackgroundVideo from "./modules/background-video.js";
import StepMenu from './modules/step-menu.js';
import AOS from 'aos';
import AjaxHandler from "./modules/ajax-handler.js";
import PostsPagination from "./modules/posts-pagination.js";
import ModularFinance from "./modules/modular-finance.js";
// import OfficesMap from "./external/offices-map.js";

// Import blocks
import CardsServices from './blocks/cards-services.js';
import GalleryGrid from './blocks/gallery-grid.js';
import ImageSlideShow from './blocks/image-slideshow.js';
import FlexibleCards from './blocks/flexible-cards.js';
import TeamSlideShow from './blocks/team-slideshow.js';
import NewsGrid from './blocks/news-grid.js';

new App();
new Hero();
new ImageSlideShow();
new FlexibleCards();
new TeamSlideShow();
new StepMenu();
new BackgroundVideo();
new CardsServices();
new GalleryGrid();
new NewsGrid();
new ModularFinance();
// new OfficesMap();

const Ajax = new AjaxHandler();
const pagination = new PostsPagination();

pagination.initPagination();
// const loadmoreposts = new LoadMorePosts();
// const maps = new Maps();

Lightbox.option({
	'showImageNumberLabel': false
});

AOS.init();

// Add minor in use functions here
window.Holmbergs = {
	init: function () {
		this.Navigation();
		this.Scripts();
	},
	Scripts() {
		$(".has-readmore").each(function () {
			const $container = $(this);

			const readMoreLabel =
				$container.data('more') ?? "Läs mer 2";
			const readLessLabel =
				$container.data('less') ?? "Stäng";

			$(this).readmore({ speed: 75, collapsedHeight: 50, lessLink: '<a href="#">' + readLessLabel + '</a>', moreLink: '<a href="#">' + readMoreLabel + '</a>' });
		});

		$('[data-counter]').counter();
	},
	Navigation() {
		$(document).on('click', '.navbar-nav .dropdown-menu', function (e) {
			e.stopPropagation();
		});

		$(window).bind("scroll", function () {
			var navHeight = 130;
			var navOffset = 100;

			$(window).scrollTop() > navHeight + navOffset
				? $("#site-header > .navbar").addClass("navbar-fixed-top")
				: $("#site-header > .navbar").removeClass("navbar-fixed-top");
		});
	}
}


window.Holmbergs.init();
